export const SET_LIST_JOBTYPEDETAIL = "SET_LIST_JOBTYPEDETAIL";
